import axios from "axios";
import { prepareImageForUpload } from "../utils/imageUploadPolicy";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => {
  const token = localStorage.getItem("ogestyle_token");
  if (!token) {
    return null;
  }

  return {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
};

export const getStorefrontSetupStatus = async () => {
  if (!API_BASE_URL) {
    throw new Error("Configuration error");
  }

  const headers = getAuthHeaders();
  if (!headers) {
    throw new Error("Authentication required");
  }

  const response = await axios.get(
    `${API_BASE_URL}/api/v2/storefront/setup-status`,
    {
      headers,
    },
  );

  return response.data;
};

export const updateStorefrontSetupStatus = async (payload) => {
  if (!API_BASE_URL) {
    throw new Error("Configuration error");
  }

  const headers = getAuthHeaders();
  if (!headers) {
    throw new Error("Authentication required");
  }

  const response = await axios.put(
    `${API_BASE_URL}/api/v2/storefront/setup-status`,
    payload,
    { headers },
  );

  return response.data;
};

export const checkStorefrontHandleAvailability = async (handle) => {
  if (!API_BASE_URL) {
    throw new Error("Configuration error");
  }

  const headers = getAuthHeaders();
  if (!headers) {
    throw new Error("Authentication required");
  }

  const response = await axios.get(
    `${API_BASE_URL}/api/v2/storefront/handle-availability`,
    {
      headers,
      params: { handle },
    },
  );

  return response.data;
};

export const uploadStorefrontSetupHeroImage = async (file) => {
  if (!API_BASE_URL) {
    throw new Error("Configuration error");
  }

  const token = localStorage.getItem("ogestyle_token");
  if (!token) {
    throw new Error("Authentication required");
  }

  const formData = new FormData();
  formData.append("image", await prepareImageForUpload(file));

  const response = await axios.post(
    `${API_BASE_URL}/api/v2/storefront/setup-hero-image`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return response.data;
};
